<template>
    <div>
      <vs-popup title="جزئیات تراکنش" :active.sync="popupDetailActive" id="crypto-history-detail">
        <div class="text-center text-6xl" v-if="!isLoading">
          <i class="cf" v-if="isFontExist(Transaction.coin.symbol)" :class="'cf-'+Transaction.coin.symbol.toLowerCase()" :style="{color:colorSymbol(Transaction.coin.symbol)}"></i>
          <img :src="publicPath+'images/currency/' + iconSymbol(Transaction.coin.symbol)" width="70px" v-else/>
        </div>

        <vs-alert color="danger" active="true" v-if="!isLoading && Transaction.reason && Transaction.status=='reject'"
                  class="mb-2" icon-pack="feather" icon="icon-alert-triangle">
          <b>{{$t('Reason for rejection')}}:</b> {{Transaction.reason}}
        </vs-alert>

        <div class="vx-row">
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-1">
              شناسه تراکنش:
            </div>
            <div class="vx-col text-primary vazir">
              <span v-if="!isLoading && Transaction">#{{Transaction.id}}</span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-1">
              وضعیت:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && Transaction">
                <vs-chip color="success" v-if="Transaction.status == 'success'">{{$t(Transaction.status)}}</vs-chip>
                <vs-chip color="warning" v-if="Transaction.status == 'pending'">{{$t(Transaction.status)}}</vs-chip>
                <vs-chip color="danger" v-if="Transaction.status == 'reject' || Transaction.status == 'unsuccessful'">{{$t(Transaction.status)}}</vs-chip>
              </span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-1">
              تاریخ ثبت:
            </div>
            <div class="vx-col vazir">
              <span v-if="!isLoading && Transaction">{{Transaction.DateTime}}</span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-1">
              ارز:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && Transaction">{{getNameCoin(Transaction.coin.symbol)[islocale]}}</span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-1">
              نوع:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && Transaction" class="flex items-center">
                <div class="h-3 w-3 rounded-full mr-1" :class="'bg-' + (Transaction.type == 'deposit'? 'success' : 'danger' )"></div>
                {{$t(Transaction.type)}}
              </span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-1">
              مقدار:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && Transaction">{{toFixFloat(Transaction.amount) + '' + Transaction.coin.symbol}}</span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3">
            <div class="vx-col mr-1">
              موجودی بعد از تراکنش:
            </div>
            <div class="vx-col">
              <span v-if="!isLoading && Transaction">{{toFixFloat(Transaction.stock) + '' + Transaction.coin.symbol}}</span>
            </div>
          </div>
          <div class="vx-col lg:w-1/2 w-full flex mb-3" v-if="Transaction && Transaction.network">
            <div class="vx-col mr-1">
              شبکه انتقال:
            </div>
            <div class="vx-col">
              {{$t(Transaction.network)}}
            </div>
          </div>

          <div class="vx-col lg:w-1/2 w-full flex mb-3" v-if="Transaction && Transaction.withdraw_fee">
            <div class="vx-col mr-1">
              کارمزد انتقال:
            </div>
            <div class="vx-col">
              {{Transaction.withdraw_fee + ' ' + (Transaction.coin.symbol)}}
            </div>
          </div>




          <vs-divider/>
          <div class="vx-col w-full mb-3">
            <p>
              توضیحات تراکنش:
            </p>
            <p class="text-center">
              <span v-if="!isLoading && Transaction">
                {{Transaction.description? $t(Transaction.description) : ' - - - - - - - - '}}
              </span>
            </p>
          </div>


          <div class="vx-col w-full mb-3" v-if="Transaction && Transaction.destination">
            <vs-divider/>
            <p v-if="Transaction.type == 'deposit'">
              آدرس کیف پول فرستنده:
            </p>
            <p v-if="Transaction.type != 'deposit'">
              آدرس کیف پول مقصد:
            </p>
            <p class="text-right" v-clipboard:copy="Transaction.destination" v-clipboard:success="onCopy" v-clipboard:error="onError">
              <vs-tooltip color="success" :text="$t('click for copy')">
                <i class="feather icon-copy"></i> {{Transaction.destination}}
              </vs-tooltip>
            </p>

            <p v-if="Transaction.destination_tag">
              تگ آدرس:
            </p>
            <p class="text-right" v-if="Transaction.destination_tag" v-clipboard:copy="Transaction.destination_tag" v-clipboard:success="onCopy" v-clipboard:error="onError">
              <vs-tooltip color="success" :text="$t('click for copy')">
                <i class="feather icon-copy"></i> {{Transaction.destination_tag}}
              </vs-tooltip>
            </p>
          </div>


          <div class="vx-col w-full mb-3" v-if="Transaction && Transaction.txid">
            <vs-divider/>
            <p>
              شناسه شبکه تراکنش(TxId):
            </p>
            <p class="text-right" v-clipboard:copy="Transaction.txid" v-clipboard:success="onCopy" v-clipboard:error="onError">
              <vs-tooltip color="success" :text="$t('click for copy')">
                <i class="feather icon-copy"></i> {{Transaction.txid}}
              </vs-tooltip>
            </p>
          </div>

          <div class="vx-col w-full mb-3" v-if="Transaction && Transaction.file">
            <vs-divider/>
            <p>
              رسید تراکنش:
            </p>
            <transition name="fade-top-2x">
              <img :src="srcImage" v-if="srcImage" class="responsive mt-1">
            </transition>
          </div>
        </div>
      </vs-popup>
    </div>
</template>

<script>
import axios from "../../../../axios";

export default {
  name: 'CryptoDetail',
  props: {
    popupDetail: {
      type: Boolean,
      required: true
    },
    idTransaction:{
      required: true
    }
  },
  data () {
    return {
      popupDetailActive: this.popupDetail,
      isLoading: false,
      Transaction: null,
      srcImage: null
    }
  },
  methods:{
    getData(){
      const self = this;
      axios.post('/history/crypto-transaction/'+ this.idTransaction)
        .then(function (response) {
          self.Transaction = response.data.transaction
          self.isLoading = false;
          if(self.Transaction.file)
            self.getFile(self.Transaction.file,'srcImage')
        }).catch(function (error) { console.log(error); self.isLoading = false;})
    }
  },
  watch: {
    popupDetail (newVal, oldVal) { // watch it
      this.popupDetailActive = newVal
      this.$emit('popupDetailChange', newVal)
    },
    popupDetailActive (newVal, oldVal) { // watch it
      this.popupDetailActive = newVal
      this.$emit('popupDetailChange', newVal)
    },
    isLoading(value){
      if(value){
        this.$vs.loading({
          container: '#crypto-history-detail',
          type: 'radius',
          scale: 1.65
        })
      }else
        this.$vs.loading.close('#crypto-history-detail > .con-vs-loading')
      }
    },
    mounted() {

    },
    created() {
      this.isLoading = true;
      this.getData();
    }
}
</script>

<style scoped>

</style>
